<template>
    <div class="inner-wrapper">
        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <ul>
                <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <router-view/>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";

export default {
    name: "AddPurchaseOrder",
    created() {
        if(localStorage.getItem('token')){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        //this.setNewPurchaseOrder(this.newOrder);
    },
    data(){
        return {
            newOrder: {
                vendor: null,
                order_id: null,
                vendor_id: null,
                is_draft : 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                vendor_notes: null,
                po_status_id: 1,
                products:[],
                selectedProducts: [],
                quote_num: null
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading',
            'setNewPurchaseOrder'
        ]),

    },
    watch: {

    },
    computed: {
        ...mapState([
            'userState',
            'purchaseOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'newPurchaseOrder'
        ])
    }
}
</script>

<style scoped>

</style>
